import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from '../ui/Button';

const PublicHeader = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationLinks = [
    { label: 'Recursos', href: '#features' },
    { label: 'Preços', href: '#pricing' },
    { label: 'Sobre', href: '#about' },
    { label: 'Contato', href: '#contact' },
  ];

  const handleSignupClick = () => {
    navigate('/authentication-hub');
  };

  const handleLoginClick = () => {
    navigate('/authentication-hub');
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="public-header">
      <div className="public-header-content">
        <div className="public-header-logo">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-blue-700 flex items-center justify-center shadow-soft">
            <Icon name="Activity" size={20} color="#FFFFFF" />
          </div>
          <span className="text-xl font-semibold text-foreground">
            {import.meta.env.VITE_APP_TITLE}&nbsp;&nbsp;
          </span>
        </div>

        <nav className="public-header-nav" aria-label="Main navigation">
          {navigationLinks?.map((link) => (
            <a
              key={link?.href}
              href={link?.href}
              className="public-header-nav-link"
            >
              {link?.label}
            </a>
          ))}
        </nav>

        <div className="public-header-actions">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLoginClick}
            className="hidden md:flex"
          >
            Entrar
          </Button>
          <Button
            variant="default"
            size="sm"
            onClick={handleSignupClick}
            iconName="ArrowRight"
            iconPosition="right"
          >
            Começar Grátis
          </Button>

          <button
            onClick={toggleMobileMenu}
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg hover:bg-muted transition-smooth"
            aria-label="Toggle mobile menu"
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={20} />
          </button>
        </div>
      </div>
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-card border-b border-border shadow-elevated">
          <nav className="flex flex-col p-4 space-y-2">
            {navigationLinks?.map((link) => (
              <a
                key={link?.href}
                href={link?.href}
                className="px-4 py-3 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-lg transition-smooth"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link?.label}
              </a>
            ))}
            <div className="pt-2 border-t border-border">
              <Button
                variant="ghost"
                size="sm"
                onClick={handleLoginClick}
                fullWidth
                className="mb-2"
              >
                Entrar
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default PublicHeader;